import React from 'react';
import {IWpAuthor} from '../../../../types/wordpress.types';
import Author from '../author/Author.component';
import PublishedDate from '../published-date/PublishedDate.component';
import {SharePost} from '../share-post/SharePost.component';
import s from './PostShare.module.scss';


interface IPostShare {
  author: IWpAuthor | null;
  publishDate: string;
}

export const PostShare = ({ author, publishDate }: IPostShare) => {
  
  return (
    <div className={`${s.postShare} ${author ? s.postShare__author : ''}`}>
      {
        author &&
        <Author
          name={author.article_author.authorName}
          picture={author.article_author.authorPicture}
        />
      }
      { publishDate &&
        <PublishedDate publishedDate={publishDate} isAuthorAvailable={!!author} />
      }
      <SharePost />
    </div>
  );
};
